/**
 * Given a key extraction function, return a function that will filter a
 * collection to return only the first instance for each extracted key.
 * @param keyExtractor function which extracts a key from a collection element
 * @return {function(*=): boolean} a filter function, providing uniqueness
 */
const uniqueFilterBuilder = keyExtractor => {
    const uniquer = new Set();
    return it => {
        const key = keyExtractor(it);
        if (uniquer.has(key)) return false;
        uniquer.add(key);
        return true;
    };
};

export default uniqueFilterBuilder;



// WEBPACK FOOTER //
// ./app/data/util/uniqueFilterBuilder.js